import { FC, useCallback, useState } from 'react';

import { HiDotsVertical } from 'react-icons/hi';
import { useHistory } from 'react-router-dom';

import { IconAccess, IconPhone } from '~/assets/icons';
import { ImageAvatarPlaceholder } from '~/assets/images';
import { Modal } from '~/components';
import { useScreen } from '~/hooks/screen';

import { StudentProps } from '../interface';

import {
  Avatar,
  Container,
  Content,
  Date,
  Info,
  InfoIcon,
  InfoText,
  Name,
  Options,
  Wrapper,
  DeleteModalContainer,
  GreenDot,
  RedDot,
} from './styles';

interface CardStudentProps {
  user: StudentProps;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleDeleteStudent: any;
}

const CardStudent: FC<CardStudentProps> = ({ user, handleDeleteStudent }) => {
  const { push } = useHistory();
  const { updateScreen } = useScreen();

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const navigateToStudent = useCallback(() => {
    updateScreen(`token`);

    push(`/professional/students/${user.student.id}`);
  }, [updateScreen, push, user]);

  const navigateToStudentEdit = useCallback(() => {
    push(`/professional/students/${user.student.id}/edit`, user);
  }, [push, user]);

  function DeleteModal() {
    return (
      <Modal isOpen={showDeleteModal} setOpen={setShowDeleteModal}>
        <DeleteModalContainer>
          <h1>Atenção</h1>

          <p>
            Ao clicar em SIM excluirá o aluno {` `}
            <strong>{user.name}</strong> da base de dados!
            <br />
            Tem certeza que deseja continuar?
          </p>

          <div>
            <button type="button" onClick={handleDeleteStudent}>
              Sim
            </button>
            <button type="button" onClick={() => setShowDeleteModal(false)}>
              Não
            </button>
          </div>
        </DeleteModalContainer>
      </Modal>
    );
  }

  return (
    <Wrapper>
      <DeleteModal />

      <Container onClick={navigateToStudent}>
        <Avatar src={user.image_url ?? ImageAvatarPlaceholder} />

        <Content>
          <Date>{user.student.birth_date ?? 'Idade não informada'}</Date>

          <Name>{user.name}</Name>

          <Info>
            <InfoIcon src={IconAccess} />
            <InfoText>{user.student.cpf}</InfoText>
          </Info>

          <Info>
            <InfoIcon src={IconPhone} />
            <InfoText>{user.cellphone}</InfoText>
          </Info>

          <Info>
            {user.student.status === 'active' ? (
              <>
                <GreenDot>
                  <div />
                </GreenDot>
                <InfoText>Ativo</InfoText>
              </>
            ) : (
              <>
                <RedDot>
                  <div />
                </RedDot>
                <InfoText>Inativo</InfoText>
              </>
            )}
          </Info>
        </Content>
      </Container>

      <Options>
        <HiDotsVertical size={30} color="#000" />

        <div>
          <button onClick={navigateToStudentEdit} type="button">
            Editar
          </button>

          <div className="divider" />

          <button onClick={() => setShowDeleteModal(true)} type="button">
            Excluir
          </button>
        </div>
      </Options>
    </Wrapper>
  );
};

export default CardStudent;
